<template>
  <div id="document">
    <modal @close="$emit('close')" width="60em">
      <div slot="header">System Documents</div>
      <div slot="body">
        <div class="title" style="font-size:1.5em">
          Documents
        </div>

        <label class="drag-drop" v-cloak @drop.prevent="$drop($event)" @dragover.prevent for="upload-doc" v-if="!readOnly">
          <h2>drag files over</h2>
        </label>
        <input id="upload-doc" ref="upload-doc" type="file" style="display:none" @change="drop($event)" multiple v-if="!readOnly" />

        <div v-if="files && files.length > 0" style="max-height:250px;overflow: auto; width:90%; margin: 1em auto; text-align:center">
          <table class="list" style="width:100%;border-collapse: collapse; margin:0 0 1em ">
            <tr v-for="doc in files" :key="doc.id">
              <td class="ellipsis">{{doc.file.name}}</td>
              <td><input type="text" v-model="doc.description" /></td>
              <td style="width:2.5em">
                <span @click="document=doc;showDeleteDocument=true">
                  <icon icoClass="flag-event-ico" selected='delete'/>
                </span>
              </td>
            </tr>
          </table>
          <button class="button is-small is-success" @click="uploadToApi()">upload files</button>
        </div>

        <div class="title" style="font-size:1.2em">
          Current Documents
        </div>
        <div v-if="objFiles && objFiles.length > 0" style="max-height:250px;overflow: auto; width:100%; margin: 1em auto; align-items:center">
          <table class="custom-table table is-fullwidth is-striped is-bordered is-hoverable" style="width:100%;border-collapse: collapse; margin:0">
            <thead>
              <th>name</th>
              <th>description</th>
              <th />
            </thead>
            <tbody>
              <tr v-for="file in objFiles" :key="file.id">
                <td>
                  <a class="ellipsis" target="_blank" @click="downloadFile(file)" :title="file.name">{{file.name}}</a>
                </td>
                <td>{{file.description }}</td>
                <td style="width:2.5em">
                  <span @click="document=file;showDeleteDocument=true;" class="delete-table">
                    <icon icoClass="docs-modal-ico" selected='delete'/>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div slot="footer" style="text-align: center;">
        <button class="button is-black" @click="$emit('close')">
          close
        </button>
        <button class="button is-primary" @click="downloadZips();showDeleteDocument = false;">
          download zip
        </button>
      </div>
    </modal>
    <modal v-if="showDeleteDocument" @close="showDeleteDocument=false" @confirm="cancel()">
      <slot slot="header"><h3 class="is-size-4"><slot name="title">Confirm action</slot></h3></slot>
      <slot name="body" slot="body">Are you sure you want to <strong>delete</strong> this document?</slot>
      <div slot="footer">
        <button class="button" @click="showDeleteDocument = false;">
          No, I'm not
        </button>
        <button class="button is-primary" @click="deleteFile(document.id);showDeleteDocument = false;">
          Yes, I'm sure
        </button>
      </div>
    </modal>

  </div>
</template>

<script>
import Modal from '@/components/Modal'
import Icon from './../svg/events'
import {mapActions, mapState} from 'vuex'
export default {
  name: 'detail-documents',
  components: {Modal, Icon},
  props: ['object', 'objectString', 'objectsString', 'type'],
  computed: {
    ...mapState({
      count: state => state.document.count,
      pageSize: state => state.document.pageSize
    }),
    pagesShown: {
      get: function () {
        var pages = [this.page]
        for (let index = 1; index <= 2; index++) {
          if (this.page - index > 0) {
            pages.push(this.page - index)
          }
          if (this.page + index <= Math.ceil(this.count / this.pageSize)) {
            pages.push(this.page + index)
          }
        }
        return pages.sort(function (a, b) { return a - b })
      }
    }
  },
  watch: {
    object (newVal) {
      if (newVal) {
        this.getDocuments(newVal.id)
      }
    }
  },
  mounted () {
    if (this.object.id) {
      this.getDocuments(this.object.id)
    }
    if (this.object.status === 'cancelled') {
      this.readOnly = true
    }
  },
  filters: {
    listToString: function (list) {
      if (!list) return ''
      list = JSON.stringify(list)
      list = list.replace(/\[|\]|"/g, '')
      list = list.replace(/,/g, ', ')
      if (list) list = list + '.'
      return list.toLowerCase()
    },
    fileName (val) {
      if (!val) return
      return val.substr(val.lastIndexOf('/') + 1)
    }
  },
  created () {
  },
  data () {
    return {
      apiUrl: '',
      document: {},
      filters: {
        licencias: [],
        descripcion: '',
        tipo: '',
        is_image: false
      },
      files: [],
      objFiles: [],
      description: '',
      page: 1,
      rowIndex: -1,
      showAddExisting: false,
      showDeleteDocument: false,
      deleteObject: {},
      readOnly: false
    }
  },
  methods: {
    ...mapActions({
      getDocs: 'attachment/listAttachment',
      uploadFile: 'attachment/saveAttachment',
      download: 'attachment/download',
      downloadZip: 'attachment/downloadZip',
      deleteAttachment: 'attachment/delete'
    }),
    assignDoc (doc) {
      this.$emit('assignExisting', doc.id)
      this.showAddExisting = false
    },
    getDocuments (obj) {
      this.getDocs({params: this.filters, id: obj}).then((response) => {
        this.objFiles = response
      })
    },
    downloadFile (fileId) {
      this.download(fileId)
    },
    downloadZips () {
      this.downloadZip(this.object)
    },
    drop (f) {
      var files = f.target.files || f.dataTransfer.files
      if (!files.length) return
      for (var i = 0; i < files.length; i++) {
        this.files.push({ file: files[i], description: '' })
      }
      const input = this.$refs['upload-doc']
      input.type = 'text'
      input.type = 'file'
    },
    uploadToApi () {
      var promises = []
      document.body.style.cursor = 'wait'
      for (var i = 0; i < this.files.length; i++) {
        var formData = new FormData()
        formData.append('file', this.files[i].file)
        formData.append('description', this.files[i].description || this.files[i].file.name)
        promises.push(this.uploadFile({formData: formData, id: this.object.id}).then(response => {
        }))
      }

      Promise.all(promises).then(() => {
        this.files = []
        this.getDocs({params: this.filters, id: this.object.id}).then((response) => {
          this.objFiles = response
          document.body.style.cursor = 'default'
        }).catch(() => {
          document.body.style.cursor = 'default'
        })
      })
    },
    deleteFile (fileId) {
      this.deleteAttachment(fileId).then(() => {
        this.getDocuments(this.object.id)
        this.deleteObject = {}
        this.showDeleteDocument = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';

#manage {
  padding-top: 4em;
}
.edit-input {
  position:relative;
  img {
    margin-left:-2em;
    height:1.2em;
    position: absolute;
    &.ok{
      margin-left:-4em;
    }
  }
}
.drag-drop {
  background: white;
  border: 1px solid $turq;
  color: $turq;
  border-style: dashed;
  margin: 1em;
  padding: 2em;
  display:block;
  cursor: pointer;
}
.record-left {
  width: 25%;
  box-sizing: border-box;
  display: inline-block;
}
.record-right {
  width: 74%;
  box-sizing: border-box;
}
.ok-icon{
  height: 1.5em;
}
.flex {
  justify-content: space-between safe;
}
tr {
  color: #333333;
  transition: .3s;
  &:hover {
    color: #B6BF05;
  }
  a {
    color: inherit;
    cursor: pointer;
  }
}
.custom-table{
  td {
    text-align: left;
  }
}
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 10em;
  display: inline-block;
}

.is-small {
  font-weight: bold;
}

.delete-modal {
  height: 6em;
  .buttons {
    display: flex;
    justify-content: center;
    padding: .5em;
    button{
      margin: .5em;
    }
  }
}
span {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/DocsModal.vue